import {PropertyApi} from "../../property/PropertiesPanel";
import relationshipApiClient, {
    RelationshipPropertyApiClient
} from "../../../../../common/apis/relationship/RelationshipPropertyApiClient";
import {PropertyCreateDto, PropertyDefinitionDto, PropertyDto} from "../../../../../common/apis/property/PropertyApi";
import {ElementPropertyDefinition} from "../../../../../common/ElementPropertyDefinitionContext";

export class RelationshipPropertyWrapperApi implements PropertyApi {

    private readonly apiClient: RelationshipPropertyApiClient;

    constructor(readonly relationshipId: string,
            readonly propertyDefinitionContext: ElementPropertyDefinition) {
        this.apiClient = relationshipApiClient;
    }

    getExistingPropertyDefinitions(): PropertyDefinitionDto[] {
        return this.propertyDefinitionContext.propertyDefinitions;
    }

    refreshExistingPropertyDefinitions(): void {
        this.propertyDefinitionContext.updatePropertyDefinitions();
    }

    getProperties(): Promise<PropertyDto[]> {
        return this.apiClient.findAllRelationshipProperties(this.relationshipId);
    }

    createProperty(name: string, type: string, value: string, propertyDefinitionId: string | undefined): Promise<PropertyDto> {
        const propertyCreate: PropertyCreateDto = {
            propDefIdentifier: propertyDefinitionId,
            name: name,
            type: type,
            value: value
        };
        return this.apiClient.createRelationshipProperty(this.relationshipId, propertyCreate);
    }

    updateProperty(propertyDefinitionId: string, value: string): Promise<void> {
        return this.apiClient.updateRelationshipProperty(this.relationshipId, propertyDefinitionId, value);
    }

    deleteProperty(propertyDefinitionId: string): Promise<void> {
        return this.apiClient.deleteRelationshipProperty(this.relationshipId, propertyDefinitionId);
    }

}